import React from 'react';
import type { GetServerSideProps, NextPage } from 'next';
import Head from 'next/head';

import { User, withAuthSsr } from 'lib/auth';
import { ServerApiService } from 'services/ServerApiService';
import { Dashboard as DashboardView } from 'components/views/app/Dashboard';
import { returnPropsOrLogout } from 'lib/auth/returnPropsOrLogout';
import { isEmpty } from 'utils/isEmpty';

interface Notifications {
  vendors: [];
  notifications: number;
  loan?: number;
}

interface Sections {
  buyer_section: Notifications;
  invite_section: Notifications;
  loan_section: Notifications;
  seller_section: Notifications;
  leasing_loan_section: Notifications;
  reloan_section: Notifications;
}

interface IDashboard {
  message: string;
  payload: Sections;
}

interface Props {
  user: User;
  dashboard: IDashboard;
}

const Dashboard: NextPage<Props> = ({ user, dashboard }) => {
  const badges = {
    buyer: dashboard.payload.buyer_section.notifications ? 'Nytt' : undefined,
    seller: dashboard.payload.seller_section.notifications ? 'Nytt' : undefined,
    loan: dashboard.payload.loan_section.notifications ? 'Nytt' : undefined,
    leasing: dashboard.payload.leasing_loan_section.notifications ? 'Nytt' : undefined,
    reloan: dashboard.payload.reloan_section.notifications ? 'Nytt' : undefined,
  };

  const activeLeasing = isEmpty(dashboard.payload.leasing_loan_section.vendors);

  const activeReloan = isEmpty(dashboard.payload.reloan_section.vendors);

  const activeLoan = dashboard.payload.loan_section.loan !== null;

  return (
    <>
      <Head>
        <title>Mitt Blipp</title>
        <meta name="robots" content="noindex" />
      </Head>
      <DashboardView
        firstName={user.firstName ?? ''}
        badges={badges}
        activeLeasing={!activeLeasing}
        activeReloan={!activeReloan}
        activeLoan={activeLoan}
      />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = withAuthSsr(async ({ req, res }) => {
  const { user } = req.session;

  const apiService = new ServerApiService(req, res);
  const dashboard = await apiService.dashboard().then((response) => response.json());

  return returnPropsOrLogout(
    {
      props: {
        user,
        dashboard,
      },
    },
    dashboard.status_code,
    dashboard.not_authenticated,
    req
  );
});

export default Dashboard;
